var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSignout24(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5A1.5 1.5 0 016 3.5h11A1.5 1.5 0 0118.5 5v.4a.5.5 0 01-1 0V5a.5.5 0 00-.5-.5H6a.5.5 0 00-.5.5v14a.5.5 0 00.5.5h11a.5.5 0 00.5-.5v-.4a.5.5 0 011 0v.4a1.5 1.5 0 01-1.5 1.5H6A1.5 1.5 0 014.5 19V5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.793 12.5l-3.147 3.146a.5.5 0 00.708.708l4-4a.5.5 0 000-.708l-4-4a.5.5 0 00-.708.708l3.147 3.146H9a.5.5 0 000 1h8.793z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSignout24);
export default __webpack_public_path__ + "static/media/icon-signout-24.c3a6e1fa.svg";
export { ForwardRef as ReactComponent };